// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.tab .tab-button {
  min-width: 240px;
  width: fit-content;
  border-radius: 8px 8px 0 0;
  background-color: var(--tab-inactive-color);
  border: 1px solid var(--tab-inactive-color);
  padding: 10px 16px;
}
.tab .tab-button.selected {
  pointer-events: none;
  background-color: var(--white-color-lightest);
  border: 1px solid var(--white-color-lightest);
}
.tab .tab-button:hover {
  background-color: var(--white-color-lightest);
  border: 1px solid var(--white-color-lightest);
}`, "",{"version":3,"sources":["webpack://./src/_core/components/common/UI/Tab.scss"],"names":[],"mappings":"AAGE;EACE,gBAAA;EACA,kBAAA;EACA,0BAAA;EACA,2CAAA;EACA,2CAAA;EAEA,kBAAA;AAHJ;AAKI;EACE,oBAAA;EACA,6CAAA;EACA,6CAAA;AAHN;AAMI;EACE,6CAAA;EACA,6CAAA;AAJN","sourcesContent":[".tab {\r\n\r\n\r\n  .tab-button{\r\n    min-width: 240px;\r\n    width: fit-content;\r\n    border-radius: 8px 8px 0 0;\r\n    background-color: var(--tab-inactive-color);\r\n    border: 1px solid var(--tab-inactive-color);\r\n\r\n    padding: 10px 16px;\r\n\r\n    &.selected{\r\n      pointer-events: none;\r\n      background-color: var(--white-color-lightest);\r\n      border: 1px solid var(--white-color-lightest);\r\n    }\r\n\r\n    &:hover{\r\n      background-color: var(--white-color-lightest);\r\n      border: 1px solid var(--white-color-lightest);\r\n    }\r\n  }\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
